import { Box, CircularProgress, useTheme } from "@mui/material";
import { AuroraGlow } from "./AuroraGlow";

/**
 * Full-screen spinner on the same aurora field as the auth screens — shown
 * by the route guards while the session is being (re)checked, so the moments
 * between signing in or out and landing on the next screen stay on one
 * continuous surface instead of flashing to a flat page.
 */
export const AuthLoadingScreen = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: "relative",
        minHeight: "100dvh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: theme.palette.background.default,
        overflow: "hidden",
      }}
    >
      <AuroraGlow />
      <CircularProgress sx={{ position: "relative", color: "#22c55e" }} />
    </Box>
  );
};
